import {
  buildForm,
  buildHtml,
  buildUrl,
  ContentRoute,
  RouteSlotInput,
} from '@caritas/ui';
import { navigate } from 'gatsby';

export const mapDonationWidget = (
  donation?:
    | DonationPageFragment
    | StockDonationPageFragment
    | SponsorshipDonationPageFragment
    | BoxDonationPageFragment,
  donationDescription?: string,
) =>
  function (): RouteSlotInput<typeof ContentRoute, 'body', 'CBoxDonation'> {
    return {
      key: 'CBoxDonation',
      input: function useDonationWidget() {
        const frequencies: { [key: string]: any } = {
          // @ts-ignore
          ...(donation?.oneTimeAmounts?.amounts
            ? // @ts-ignore
              { oneTime: donation?.oneTimeAmounts }
            : {}),
          // @ts-ignore
          ...(donation?.monthlyAmounts?.amounts
            ? // @ts-ignore
              { monthly: donation?.monthlyAmounts }
            : {}),
          // @ts-ignore
          ...(donation?.yearlyAmounts?.amounts
            ? // @ts-ignore
              { yearly: donation?.yearlyAmounts }
            : {}),
        };

        const defaultFrequency: 'oneTime' | 'monthly' | 'yearly' = [
          'Donation',
          'StockDonation'
        ].includes(donation?.__typename as string)
          ? 'oneTime'
          : ['SponsorshipDonation'].includes(
              donation?.__typename as string,
            )
          ? 'monthly'
          : 'oneTime';

        const availableAmounts: { [key: string]: any } = {};
        const defaultAmounts: { [key: string]: any } = {};
        const customAmounts: { [key: string]: any } = {};

        Object.keys(frequencies).forEach((frequency) => {
          if (
            frequencies[frequency]?.amounts &&
            frequencies[frequency]?.amounts.length
          ) {
            if (
              frequencies[frequency].amounts &&
              frequencies[frequency].amounts.includes('*')
            ) {
              customAmounts[frequency] = true;
            }
            defaultAmounts[frequency] = frequencies[frequency]?.default;
            availableAmounts[frequency] = frequencies[frequency].amounts.filter(
              (amount: string) => amount !== '*',
            );
          }
        });
        return [
          {
            Subheading: donation?.callToAction
              ? buildHtml(donation.callToAction)
              : undefined,
            content: {
              items: donation
                ? [
                    {
                      key: 'donationWidget',
                      input: {
                        Form: buildForm({
                          initialValues: {
                            amount: `${
                              defaultAmounts[defaultFrequency] ||
                              defaultAmounts['monthly'] ||
                              defaultAmounts['yearly']
                            }`,
                            // customAmount: 100,
                            // customAmountIsActive: false,
                            // period: 'oneTime',
                          },
                          onSubmit: (values) => {
                            // Redirect to donation page with state
                            navigate(
                              // @ts-ignore
                              buildUrl([donation.path], {
                                // @ts-ignore
                                amount: values?.customAmount || values.amount,
                                // @ts-ignore
                                custom: !!values?.customAmount,
                                // @ts-ignore
                                frequency: values?.period || defaultFrequency,
                                ...(donationDescription
                                  ? { description: donationDescription }
                                  : {}),
                              }),
                              {
                                // We need to pass values for the RaiseNow widget here
                                // - amount: selected by visitor
                                // - frequency: static based on donation purpose type
                                //       - Simple donation and climate share it's always one-time
                                //       - sponsorship it's monthly
                              },
                            );
                          },
                        }),
                        periods: [
                          ...(availableAmounts.oneTime
                            ? [
                                {
                                  period: {
                                    value: 'oneTime',
                                    displayCustomAmount: customAmounts.oneTime,
                                    defaultValue: defaultAmounts.oneTime,
                                  },
                                  items: availableAmounts?.oneTime?.map(
                                    (amount: string) => ({
                                      amount: amount,
                                    }),
                                  ),
                                },
                              ]
                            : []),
                          ...(availableAmounts?.monthly
                            ? [
                                {
                                  period: {
                                    value: 'monthly',
                                    displayCustomAmount: customAmounts.monthly,
                                    defaultValue: defaultAmounts.monthly,
                                  },
                                  items: availableAmounts?.monthly?.map(
                                    (amount: string) => ({
                                      amount: amount,
                                    }),
                                  ),
                                },
                              ]
                            : []),
                          ...(availableAmounts?.yearly
                            ? [
                                {
                                  period: {
                                    value: 'yearly',
                                    displayCustomAmount: customAmounts.yearly,
                                    defaultValue: defaultAmounts.yearly,
                                  },
                                  items: availableAmounts?.yearly?.map(
                                    (amount: string) => ({
                                      amount: amount,
                                    }),
                                  ),
                                },
                              ]
                            : []),
                        ],
                        type:
                          donation?.__typename === 'StockDonation'
                            ? 'climate'
                            : donation?.__typename === 'Donation'
                            ? 'donation'
                            : donation?.__typename === 'SponsorshipDonation'
                            ? 'sponsorship'
                            : 'donation',
                      },
                    },
                  ]
                : [],
            },
          },
          200,
        ];
      },
    };
  };
